import { Link } from "react-router-dom";
import { STATES, CITIES, stateSlug, cityPath } from "@/lib/constants";
import { useSeo } from "@/lib/seo";
import SEO from "@/lib/seoContent.json";

export default function StatesIndex() {
  useSeo({
    title: SEO.indexTitle,
    description: SEO.indexDescription,
  });
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16" data-testid="states-index-page">
      <span className="eyebrow">Browse by state</span>
      <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight mt-4">1031 qualified intermediaries by state</h1>
      <p className="text-white/55 mt-3 max-w-2xl">{SEO.indexIntro}</p>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 mt-10">
        {STATES.map(([c, n]) => (
          <Link key={c} to={`/1031-exchange/${stateSlug(c)}`} data-testid={`states-index-${c.toLowerCase()}`}
            className="glass-card !rounded-2xl px-4 py-4 flex items-center gap-3 hover:border-qi-pink/50 hover:bg-white/[0.07] transition-colors group">
            <span className="font-mono text-xs text-qi-pink w-6">{c}</span>
            <span className="text-sm font-semibold text-white/80 group-hover:text-white">{n}</span>
          </Link>
        ))}
      </div>
      <span className="eyebrow block mt-16">Top metros</span>
      <div className="flex flex-wrap gap-2 mt-5" data-testid="states-index-cities">
        {CITIES.map(([c, s]) => (
          <Link key={`${c}-${s}`} to={cityPath(c, s)} data-testid={`states-index-city-${s.toLowerCase()}-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className="text-sm bg-white/[0.04] border border-white/10 rounded-full px-4 py-2 text-white/70 hover:border-qi-pink/50 hover:text-white transition-colors">{c}, {s}</Link>
        ))}
      </div>
    </div>
  );
}
